/**
 * Data system application status check mock
 */

// Utils
import { RowHeader } from 'utils/types';
import { ParamsGetListSetting } from 'utils/constants';

// Models
import { IParamGetList } from 'models/UserRequest';

export const headerApplicationStatusCheck: RowHeader[] = [
  { id: 'no', label: 'No', position: 'center', haveSort: false },
  { id: 'title', label: '申込情報' },
  { id: 'edit', label: '', haveSort: false },
  { id: 'created_at', label: '申請日' },
  { id: 'company_name', label: '企業名/団体名' },
  { id: 'department', label: '所属' },
  { id: 'username', label: '名前' },
  { id: 'email', label: 'メールアドレス' },
  { id: 'address', label: '住所' },
  { id: 'company_phone_number', label: '会社電話番号' },
  { id: 'phone_number', label: '携帯電話番号' },
  { id: 'description', label: 'メモ' },
];

export const defaultParamsApplicationSettingCheck: IParamGetList = {
  keyword: '',
  order_by: 'desc',
  sort_name: 'created_at',
  page: ParamsGetListSetting.DEFAULT_PAGE as number,
  per_page: ParamsGetListSetting.ROW_PER_PAGE as number,
  service_id: null,
};
